import { type IRenderer } from '../types';
import { Console } from './console';
import { MemoryBuffer } from './memoryBuffer';

export { Console } from './console';
export { MemoryBuffer } from './memoryBuffer';
export const DEFAULT_RENDERERS: IRenderer[] = [new Console(), new MemoryBuffer()];
